import { get, put, post } from 'services/api-client';

const clientService = {
  create: (data) => post(`/client/create`, data),

  update: (data) => put('/client/update', data),

  get: (id) => get(`/client/${id}`),

  getByUserId: (userId) => get(`/client/user/${userId}`),

  resendInvite: (id) => get(`/client/${id}/resend-invite`),

  getForFilter: () => get(`/client/select-list/filter`),

  regenerateApiKeys: (id) => post(`/client/user/${id}/regenerate/api-keys`),

  loadApiKeys: (userId) => get(`/client/user/${userId}/api-keys`),
}

export default clientService;
